<template>
    <div>
        <b-form-group>
            <b-input-group>
            <b-form-input type="text" v-model="inputPersonName" id="personName"></b-form-input>
            <!-- Attach Left button -->
            <b-input-group-append>
                <b-button variant="primary" @click="openPersonModal"><i class="fa fa-search"></i></b-button>
            </b-input-group-append>
            </b-input-group>
        </b-form-group>

        <b-modal
              v-model="personModal"
              id="person-modal"
              centered
              hide-footer
              title="Pessoa Física/Jurídica"
              size="xl">
                
            <b-form @submit.stop.prevent="onSubmit">
                <div class="animated fadeIn">
                
                    <b-row>
                        <b-col cols="auto">
                            <b-form-group>
                                <label for="name">Código</label>
                                <b-form-input v-model="filters.code" type="text" id="code" placeholder="Código"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col cols="auto">
                            <b-form-group>
                                <label for="name">Filtro</label>
                                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col cols="auto">
                            <b-form-group>
                                <label for="name">Tipo de Pessoa</label>
                                <b-form-select v-model="filters.typeId" id="filterType" :plain="true" :options="selectTypeDDL" >
                                </b-form-select>
                            </b-form-group>
                        </b-col>

                        <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                            <b-form-group>
                                <p></p>
                                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                            </b-form-group>
                        </b-col>
                        
                        <b-col cols="auto" class="">
                            <b-form-group >
                                <label for="perPage">Linhas</label>
                                <b-form-select v-model="table.perPage" id="perPage"
                                    :plain="true"
                                    :options="[5,10,20,50,100]">
                                </b-form-select>
                            </b-form-group>
                        </b-col>

                    </b-row>

                    <b-table
                        :items="filteredItems"
                        :fields="table.fields"
                        :select-mode="table.selectMode"
                        responsive="sm"
                        ref="selectableTable"
                        selectable
                        :primary-key="table.primaryKey"
                        :tbody-transition-props="table.transProps"
                        sort-icon-left
                        @row-clicked="rowClicked"
                        :per-page="table.perPage"
                        :current-page="table.currentPage"
                        :busy="table.isBusy"
                        hover
                        striped>
        
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Carregando...</strong>
                            </div>
                        </template>
                        
                    </b-table>
                    <nav>
                        <b-pagination :total-rows="table.totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Anterior" next-text="Próximo" />
                    </nav>


                </div>
            </b-form>
     
        </b-modal>

    </div>
</template>

<script>

import axios from "axios";

export default {
  name: "PersonComponent",
  props: {
    companyId: String,
    personName: String
  },
  data() {
    return {
        items: [],

        typeDDL: [],
        inputPersonName: this.personName,

        personModal: false,
  
        filters: {
            st: 'A',
            code: '',
            key: '',
            typeId: 0
        },
        table: {
            fields: [
                //{key: 'show_details', label: "", thStyle: { width: "40px" } },
                {key: 'id', label: 'Código', sortable: true, class: 'text-center', thStyle: { width: "100px" } },
                //{key: 'costcenter', label: 'Centro de Custo', sortable: true },
                {key: 'name', label: 'Pessoa', sortable: true },
                //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
                //{key: 'totalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
                //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
                //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
                //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
                //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
            ],
            modes: ['multi', 'single', 'range'],
            selectMode: 'multi',
            primaryKey: 'id',
            isBusy: false,
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            transProps: {
                name: 'flip-list'
            }
        }
    }
  },
  computed: {
    selectTypeDDL: function() {
      var list = [...this.typeDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },
    filteredItems() {
        try {
            return this.items.filter(item => {
                return (this.filters.st == 0 || item.st == this.filters.st)     
                //&& (!this.filters.costCenterId || this.filters.costCenterId == null || String(item.costCenterCode).startsWith(String(this.filters.costCenterId)) )
                })
        }
        catch(e) {
            return this.items;
        }
    }
  },
  watch: {
    companyId: {
      immediate: true,
      handler(newValue) {
        this.items = []
        //this.getState(newValue);
      },
    },
    personName: {
      immediate: true,
      handler(newValue) {
        this.inputPersonName = newValue;
      }
    }
  },
  methods: {

    closePersonModal() {
        this.personModal = false
    },
    openPersonModal() {
        this.personModal = true
    },

    rowClicked(item) {

        if(item) {
            var selectedItem = {
                id: item.id,
                name: item.name,
                alias: item.alias,
                doc: (item.doc ? (item.doc.length > 11 ? this.$utils.formatCNPJ(item.doc) : this.$utils.formatCPF(item.doc)) : '') 
            }
            
            this.inputPersonName = item.name
            this.$emit('item-selected', selectedItem);
            this.closePersonModal()
        }
        
    },

    async getType() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/person/type/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.typeDDL = resp.data.obj;
        })
        .catch(function(error) {
            console.log(error);
        });
       
    },

    async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        if((s.filters.code && s.filters.code.length > 0) || (s.filters.key && s.filters.key.length > 0)) {
          
            await axios.get(
                this.$store.state.ws_url + "/person?companyId=" + s.companyId + "&code=" + s.filters.code + "&key=" + s.filters.key + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.items = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
        }
        else {
            console.log("Entre com um filtro de pesquisa")
        }
       
    }
   
  },
  mounted: function() {
    this.getType()
  }
  
};

</script>
